import { render, staticRenderFns } from "./S4cAgingTrend.vue?vue&type=template&id=08176ca4&scoped=true"
import script from "./S4cAgingTrend.vue?vue&type=script&lang=ts"
export * from "./S4cAgingTrend.vue?vue&type=script&lang=ts"
import style0 from "./S4cAgingTrend.vue?vue&type=style&index=0&id=08176ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08176ca4",
  null
  
)

export default component.exports